module.exports = __webpack_public_path__ + "static/media/internal_env_2_media_12.08f9aaab.webp";